import { useCallback } from 'react';
import { useGetErrorResponseMessage } from 'js/hooks/server';

export const useResendCode = ({
    setError,
    isMounted,
    resendHandler,
    isResendDisabled,
    isRecaptchaVisible,
    setIsResendDisabled,
    setIsRecaptchaVisible,
    setIsResendWarningShown
}) => {
    const getErrorResponseMessage = useGetErrorResponseMessage();

    return useCallback(async (event) => {
        event.preventDefault();

        if (isResendDisabled || isRecaptchaVisible) {
            return;
        }

        setIsResendDisabled(true);

        try {
            setError('');
            await resendHandler();
            setIsResendWarningShown(true);
        } catch (error) {
            const data = error?.data || error?.response?.data || {};

            if (data.sessionValidationData?.SessionValidationBy2FAData || data.errorCode === 303) {
                setIsResendWarningShown(true);

                return;
            }

            if (data.errorCode === 301) {
                setIsRecaptchaVisible(true);
                isMounted() && setIsResendDisabled(false);

                return;
            }

            isMounted() && setIsResendDisabled(false);
            isMounted() && setError(getErrorResponseMessage(error));
        }

    }, [
        setError,
        isMounted,
        resendHandler,
        isResendDisabled,
        isRecaptchaVisible,
        setIsResendDisabled,
        setIsRecaptchaVisible,
        getErrorResponseMessage,
        setIsResendWarningShown
    ]);
};
